import { render, staticRenderFns } from "./myShop.vue?vue&type=template&id=1b65bc2e&scoped=true"
import script from "./myShop.vue?vue&type=script&lang=js"
export * from "./myShop.vue?vue&type=script&lang=js"
import style0 from "./myShop.vue?vue&type=style&index=0&id=1b65bc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65bc2e",
  null
  
)

export default component.exports